module.exports = __webpack_public_path__ + "static/img/ht_bg.9485025.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ht_bg.jpg
// module id = iFNU
// module chunks = 1